import React from "react";
import moment from "moment";
import parse from "html-react-parser";
import Image from "../Image/Image";
import BlogPostAdd from "../BlogPostAdd/BlogPostAdd";
import Grid from "../Grid/Grid";
import DocumentCard from "../Card/DocumentCard";
import SEO from "../SEO/SEO";
import Author from "../Author/Author";
import TOC from "../TableOfContent/TableOfContent";
import { GlobalContext } from "../../context/GlobalContext";
import StockInfo from "../StockInfo/StockInfo";
import parseHTML from "../../helpers/parseHTML";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandPointer } from "@fortawesome/free-solid-svg-icons";

function BlogPost({ meta, data, author, showInfo, category, isAddress }) {
  const { isMobile } = React.useContext(GlobalContext);

  const [showBlogAdditional, setShowBlogAdditional] = React.useState(false);
  const [showAuthorData, setShowAuthorData] = React.useState(false);

  const contentRef = React.useRef(null);
  const conclusionRef = React.useRef(null);
  const [toc, setToc] = React.useState([]);

  React.useEffect(() => {
    //* get table of content out of text
    if (contentRef.current && conclusionRef.current) {
      const headings = contentRef.current.querySelectorAll("h5");
      const conclusionHeading = conclusionRef.current.querySelectorAll("h5");
      const tocItems = [
        ...Array.from(headings),
        ...Array.from(conclusionHeading),
      ].map((heading, index) => {
        const id = `toc${index}`;
        //* add ID for functional linking
        heading.id = id;
        return { id, text: heading.innerText };
      });
      setToc(tocItems);
    }
  }, [data?.text, data?.conclusion]);

  return (
    <>
      <SEO
        title={data?.title}
        keywords={data?.keywords}
        description={meta?.description}
        type="article"
        url={window.location.href}
        image={data?.image}
        ticker={data?.ticker}
      />
      <Author
        data={author}
        visible={showAuthorData}
        setVisible={setShowAuthorData}
      />

      {showInfo && (
        <BlogPostAdd
          data={meta}
          visible={showBlogAdditional}
          setShowVisible={setShowBlogAdditional}
          category={category}
          releaseDate={data?.releaseDate}
        />
      )}
      <div className="article-main">
        {isMobile && (
          <div className="article-image-wrapper">
            {data?.image && (
              <Image
                height="200px"
                source={data?.image}
                alternativetext="Image of that articel"
                className="article-main-image card-img-top"
              />
            )}
            <div className="article-image-filter-mobile">
              <div className="article-base-info-mobile">
                {meta?.logo && (
                  <a onClick={() => setShowBlogAdditional((prev) => !prev)}>
                    <div className="relative">
                      <Image
                        source={meta?.logo}
                        className="article-logo"
                        alternativetext={`${data?.ticker} logo`}
                      />
                      <FontAwesomeIcon
                        icon={faHandPointer}
                        className="mobileLogoIconOverlay"
                      />
                    </div>
                  </a>
                )}
              </div>
            </div>
          </div>
        )}
        {!isMobile && (
          <div className="article-image-container">
            <div className="article-image-section">
              {data?.image && (
                <>
                  <Image
                    height="420px"
                    source={data?.image}
                    alternativetext="Image of that articel"
                    className="article-main-image card-img-top"
                  />
                  <div className="article-image-white-gradient-overlay" />
                </>
              )}
            </div>
            <div className="article-image-meta">
              <div>
                <div className="article-base-info">
                  <a onClick={() => setShowBlogAdditional((prev) => !prev)}>
                    {meta?.logo && (
                      <div className="relative">
                        <Image
                          source={meta?.logo}
                          className="article-logo"
                          alternativetext={`${data?.ticker} logo`}
                        />
                        <FontAwesomeIcon
                          icon={faHandPointer}
                          className="logoIconOverlay"
                        />
                      </div>
                    )}
                  </a>

                  <h4 className="text-dark text-muted text-truncate">
                    {meta?.name}
                  </h4>

                  <div
                    id="meta-description"
                    className={`text-muted ${
                      isAddress ? "text-center" : "text-left"
                    } article-base-description article-base-description-overflow`}
                  >
                    {meta?.description && parse(meta?.description)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="article-header-area text-center">
          <h1 className="text-light article-header">{data?.title}</h1>
          <small
            className="text-muted article-meta"
            onClick={() => author && setShowAuthorData((prev) => !prev)}
          >{`${data?.author}`}</small>
          <small className="text-muted article-meta">{` | ${moment(
            data?.releaseDate
          )?.format("DD.MM.YYYY")}`}</small>
        </div>

        <TOC sections={toc} />

        <div
          id="data-text"
          ref={contentRef}
          className={`${!isMobile && "article-text"} ${
            isMobile ? "text-left" : "text-justify"
          } text-light`}
        >
          {data?.text && parseHTML(data?.text, data)}
        </div>
        {meta?.stockdata && (
          <>
            <StockInfo
              stockdata={meta?.stockdata}
              releaseDate={data?.releaseDate}
            />
          </>
        )}

        <div
          ref={conclusionRef}
          className={`${!isMobile && "article-text"} ${
            isMobile ? "text-left" : "text-justify"
          } text-light`}
        >
          {data?.conclusion && parseHTML(data?.conclusion, data)}
        </div>
        {data?.documents && Object.values(data?.documents)?.length > 0 && (
          <>
            <br />
            <div
              className={`${!isMobile && "article-text"} ${
                isMobile ? "text-left" : "text-justify"
              } text-light`}
            >
              <h5>Dokumente</h5>
              <Grid>
                {Object.values(data?.documents)?.map((item) => (
                  <DocumentCard title={item?.name} link={item?.link} />
                ))}
              </Grid>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default BlogPost;
